import { type ParsedMailbox } from 'email-addresses';
import React from 'react';

import Link from '@dashboard/components/mui-atoms/Link';
import { useContactByEmailAddressQuery } from '@dashboard/generated/wp/platform';
import { useContactShowHref } from '@dashboard/hooks/route/hrefs';

type Props = {
  mailbox: ParsedMailbox;
};

export default function ParsedMailboxChip({ mailbox }: Props) {
  const emailAddress = mailbox.address;
  const displayValue = mailbox.node?.tokens ?? emailAddress;

  const { data } = useContactByEmailAddressQuery({ variables: { emailAddress } });

  const contact = data?.findOneContact;

  if (!contact) {
    return <>{displayValue}</>;
  }
  return <ParsedMailboxChipLink id={contact.id}>{displayValue}</ParsedMailboxChipLink>;
}

type LinkProps = {
  id: string;
  children: string;
};
function ParsedMailboxChipLink({ id, children }: LinkProps) {
  const href = useContactShowHref({ id });
  return (
    <Link underline="hover" href={href}>
      {children}
    </Link>
  );
}
